import React from 'react';
import { soundsVolume } from '@/utils/constants';

export const playSound = (
    audioRef: React.MutableRefObject<HTMLAudioElement | null>,
    soundsEnabled: boolean
) => {
    if (audioRef.current) {
        audioRef.current.volume = soundsVolume;
        soundsEnabled && audioRef.current.play();
    }
};
